<section [formGroup]="parentForm()">
  @if (showStorageClass()) {
    <div
      class="row"
      [class.align-items-center]="isCompactLayout()"
      [class.justify-content-start]="isCompactLayout()">
      @if (isCompactLayout()) {
        <div class="col-auto fw-bold">
          <ng-container *ngTemplateOutlet="storageClassLabel"></ng-container>
        </div>
      }

      <div class="col-4">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'label'"
          [bindValue]="'value'"
          [clearable]="false"
          [formControlName]="isVM() ? 'storageClass' : 'StorageClass'"
          [id]="'advancedOptionsStorageClass'"
          [isAutoWidth]="true"
          [items]="storageClasses()"
          [label]="isCompactLayout() ? null : storageClassLabel"
          [searchable]="false"
          (change)="storageClassChange.emit($event)">
          <ng-template
            #mbsSelectOptionTmp
            let-item="item">
            <div class="d-flex flex-column justify-content-between">
              <div
                class="d-flex"
                [class.fw-bold]="item.value === parentForm().get(isVM() ? 'storageClass' : 'StorageClass').value">
                {{ item.label }}
              </div>
              <div class="d-flex">{{ item.description1 }}</div>
              <div class="d-flex">{{ item.description2 }}</div>
            </div>
          </ng-template>
        </mbs-select>
      </div>
    </div>
  }

  @if (showAzureTires()) {
    <div
      class="row"
      [class.align-items-center]="isCompactLayout()"
      [class.justify-content-start]="isCompactLayout()">
      @if (isCompactLayout()) {
        <div class="col-auto fw-bold">
          <ng-container *ngTemplateOutlet="azureAccessTierLabel"></ng-container>
        </div>
      }

      <div class="col-3">
        <mbs-select
          formControlName="azureAccessTier"
          [appendTo]="'.modal-content'"
          [bindLabel]="'label'"
          [bindValue]="'value'"
          [clearable]="false"
          [id]="'advancedOptionsAzureAccessTier'"
          [isAutoWidth]="true"
          [items]="accessTires()"
          [label]="isCompactLayout() ? null : azureAccessTierLabel"
          [searchable]="false"
          (change)="azureTierChange.emit($event)">
          <ng-template
            #mbsSelectOptionTmp
            let-item="item">
            <div class="d-flex flex-column justify-content-between">
              <div
                class="d-flex"
                [class.fw-bold]="item.value === parentForm().get('azureAccessTier').value">
                {{ item.label }}
              </div>
              <div class="d-flex">{{ item.description1 }}</div>
              <div class="d-flex">{{ item.description2 }}</div>
            </div>
          </ng-template>
        </mbs-select>
      </div>
    </div>
  }
</section>

<ng-template #storageClassLabel>
  {{ 'wizards:storage_class_label' | i18next }}
</ng-template>

<ng-template #azureAccessTierLabel>
  {{ 'wizards:access_tier_label' | i18next }}
</ng-template>
